// extracted by mini-css-extract-plugin
export default {"container":"GoogleCallBack_container__13hOe"};